export enum I18nKeyEnum {
    TITLE = 'title',
    NAME ='name',
    ERROR_NAME_REQUIRED = 'error_name_required',
    ERROR_INVALID_NUMBER = 'error_invalid_number',
    ERROR_NUMBER_REQUIRED = 'error_number_required',
    CANCEL = 'cancel',
    COUNTRY = 'country',
    NUMBER = 'number',
}


export type I18nKey = I18nKeyEnum;
export type Language = LanguageEnum;

export enum LanguageEnum {
    DE = 'DE',
    EN = 'EN'
}

export type Translation = {
    [key in I18nKey]: I18nTranslation
};

export type I18nTranslation = {
    [lang in Language]: string;
}

export const translations: Translation = {
    [I18nKeyEnum.TITLE]: {
        [LanguageEnum.DE]: '....',
        [LanguageEnum.EN]: '...'
    },
    [I18nKeyEnum.NAME]: {
        [LanguageEnum.DE]: 'Geben Sie Ihren Namen ein',
        [LanguageEnum.EN]: 'Enter your name'
    },
    [I18nKeyEnum.ERROR_INVALID_NUMBER]: {
        [LanguageEnum.DE]: 'Ungültige Telefonnummer',
        [LanguageEnum.EN]: 'Invalid phone number'
    },
    [I18nKeyEnum.ERROR_NUMBER_REQUIRED]: {
        [LanguageEnum.DE]: 'Bite fügen Sie Ihre Nummer ein',
        [LanguageEnum.EN]: 'Please add your phone number'
    },
    [I18nKeyEnum.COUNTRY]: {
        [LanguageEnum.DE]: 'Land',
        [LanguageEnum.EN]: 'Country'
    },
    [I18nKeyEnum.CANCEL]: {
        [LanguageEnum.DE]: 'Abbrechen',
        [LanguageEnum.EN]: 'Cancel'
    },
    [I18nKeyEnum.NUMBER]: {
        [LanguageEnum.DE]: 'lokale Nummer',
        [LanguageEnum.EN]: 'local number'
    },
    [I18nKeyEnum.ERROR_NAME_REQUIRED]: {
        [LanguageEnum.DE]: 'Bitte tragen Sie Ihren Namen für den Rückruf ein',
        [LanguageEnum.EN]: 'Please add your name for the callback'
    }
};
